import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, Modal, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { editInscription, getInscriptions, getInscriptionsByClub, cancelAllActiveInscriptionsByClub } from '../../../../actions/activities/inscriptionsActions'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import ActivitiesSubMenu from '../../../../components/menus/ActivitiesSubMenu'
import InscriptionSummary from '../../../../components/Activities/InscriptionSummary'
import Swal from 'sweetalert2'
import useAuth from '../../../../context/auth/useAuth'
import ClubBreadCrumbs from '../../../../components/breadcrumbs/ClubBreadCrumbs'
import Loader from '../../../../components/design/Loader/Loader'
import * as XLSX from 'xlsx'
import AxiosControl from '../../../../context/axios/AxiosControl'

export default function Inscriptions({usertype, isclub, inscriptionselected, handleInscriptionSelect}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()
    const Axios = AxiosControl()

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const {inscriptions, loadinginscriptions, pagination, resultinscription, cancelAllCount} = useSelector(state=>state.inscriptions)
    const {club} = useSelector(state=>state.clubs)

    const [typeform, setTypeform] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [allRowsSelected, setAllRowsSelected] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [debouncedSearch, setDebouncedSearch] = useState('')

    const translatedInscriptions = inscriptions?.map(inscription => ({
        ...inscription,
        translatedStatus: t('inscriptions.status' + inscription.status),
    }))
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebouncedSearch(searchInput.trim())
        }, 350)

        return () => clearTimeout(timeoutId)
    }, [searchInput])

    useEffect(() => {
        const requestLimit = allRowsSelected ? -1 : rowsPerPage
        if(clientauth){
            if(isclub){
                dispatch(getInscriptionsByClub(club?._id, false, currentPage, requestLimit, debouncedSearch))
            }else{
                dispatch(getInscriptions(currentPage, requestLimit, debouncedSearch))
            }
        }
        // eslint-disable-next-line
    },[dispatch, clientauth, club?._id, isclub, currentPage, rowsPerPage, debouncedSearch, allRowsSelected])

    useEffect(() => {
        setCurrentPage(1)
    }, [club?._id, isclub])

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handleRowsPerPageChange = (newPerPage) => {
        const perPageNumber = Number(newPerPage)
        const totalRows = Number(pagination?.total || 0)
        const hasNumericPerPage = Number.isFinite(perPageNumber) && perPageNumber > 0
        const normalizedPerPageValue = String(newPerPage || '').trim().toLowerCase()
        const showAll =
            normalizedPerPageValue === 'all' ||
            normalizedPerPageValue === 'todos' ||
            newPerPage === -1 ||
            !hasNumericPerPage ||
            (totalRows > 0 && hasNumericPerPage && perPageNumber >= totalRows)
        setAllRowsSelected(showAll)
        setRowsPerPage(hasNumericPerPage ? perPageNumber : (totalRows > 0 ? totalRows : 25))
        setCurrentPage(1)
    }

    const handleSelectChange = (inscription, value) => {
        if(value==='3'){
            Swal.fire({
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: t('global.yes'),
                cancelButtonText: t('global.no'),
                icon: 'warning',
                text: t('inscriptions.cancelSecure')
            }).then((newresult) => {
                if (newresult.isConfirmed) {
                    dispatch(editInscription(inscription, value, 'status', 'superadmin'))
                }
            })
        }else{
            dispatch(editInscription(inscription, value, 'status', 'superadmin'))
        }
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('es-ES')
    }
	const columnsInscriptions = [
        {
            name: t('inscriptions.client'),
            cell: inscription =>
                <div
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.client?.firstname+' '+inscription?.client?.lastname}
                </div>,
            selector: (inscription) => inscription?.client?.firstname+' '+inscription?.client?.lastname,
            sortable: false,
        },{
            name: t('users.email'),
            cell: inscription => inscription?.clientEmail || '',
            selector: (inscription) => inscription?.clientEmail || '',
            sortable: true,
        },{
            name: t('users.phone'),
            cell: inscription => inscription?.client?.phone || '',
            selector: (inscription) => inscription?.client?.phone || '',
            sortable: true,
        },{
            name: t('inscriptions.club'),
            cell: inscription =>
                <div
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.club?.name}
                </div>,
            selector: (inscription) => inscription?.club?.name,
            sortable: false,
        },{
            name: <>{t('groups.activity')} / {t('groups.category')}</>,
            cell: inscription =>
                <div
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.activity?.title} / {inscription?.category?.title}
                </div>,
            selector: (inscription) => inscription?.activity?.title+' / '+inscription?.category?.title,
            sortable: false,
        },{
            name: <>{t('inscriptions.group')} / {t('inscriptions.horary')}</>,
            cell: inscription =>
                <>{inscription?.group?.title} / {inscription?.horary?.name}</>,
            selector: (inscription) => inscription?.group?.title+' / '+inscription?.horary?.name,
            sortable: false,
        },{
            name: t('inscriptions.status'),
            center: 'true',
            cell: inscription => inscription.translatedStatus,
            selector: (inscription) => inscription.translatedStatus,
            sortable: true,
        },{
            name: t('inscriptions.paymentStatus'),
            center: 'true',
            cell: inscription =>
                !inscription.paymentStatus && inscription.paymentStatus !== 0
                    ?
                        <></>
                    :
                        <span className={`p-2 text-white ${inscription.paymentStatus === 0 ? 'bg-success' : inscription.paymentStatus === 1 ? 'bg-warning' : 'bg-danger'}`}>
                            {
                                inscription.paymentStatus === 0
                                    ?
                                        <i className='fas fa-check'/>
                                    :
                                        inscription.paymentStatus === 1
                                            ?
                                                <i className='fas fa-clock'/>
                                            :
                                                <i className='fas fa-x'/>
                            }
                        </span>
            ,
            selector: (inscription) => inscription.paymentStatus === 0 ? 'success' : inscription.paymentStatus === 1 ? 'warning' : 'danger',
            sortable: false,
        },{
            name: t('inscriptions.actions'),
            center: 'true',
            width:'120px',
            cell: inscription =>
                <div className='d-flex justify-content-around w-100'>
                    <div
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('view')
                            setShow(true)
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.seeinscription')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/eyeopen.svg" alt="eyes" height={16}/>
                        </OverlayTrigger>
                    </div>
                    <div
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('edit')
                            setShow(true)
                        }}
                        className='table-link'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.editinscription')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/pencil.svg" alt="pencil" height={16}/>
                        </OverlayTrigger>
                    </div>
                    {inscription?.status === "0" || inscription?.status === "4" ?
                        <>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.approveinscription')}</Tooltip>}
                            >
                                <i className="fas fa-check px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "1")}></i>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        </>
                    :
                        inscription?.status !== "3" ?
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        :
                            ''
                    }
                </div>,
            selector: (inscription) => inscription?.group?.title,
            sortable: false,
        }
	]

    const exportToExcel = async () => {
        if (!inscriptions || inscriptions.length === 0) return

        // Fallback: if list endpoints omit questions, hydrate each inscription from detail endpoint.
        const inscriptionsWithQuestions = await Promise.all(inscriptions.map(async (inscription) => {
            if (Array.isArray(inscription?.questions) && inscription.questions.length > 0) {
                return inscription
            }

            try {
                const response = await Axios.get(`/api/inscription/getinscription/${inscription?._id}`, {
                    headers: { auth: sessionStorage.getItem('jwt') }
                })
                return {
                    ...inscription,
                    questions: response?.data?.inscription?.questions || inscription?.questions || []
                }
            } catch (error) {
                return inscription
            }
        }))

        // Build a stable set of question columns for all exported inscriptions.
        const allQuestions = []
        const seenQuestions = new Set()
        inscriptionsWithQuestions.forEach((inscription) => {
            const inscriptionQuestions = Array.isArray(inscription?.questions) ? inscription.questions : []
            inscriptionQuestions.forEach((questionItem) => {
                const questionText = String(questionItem?.question || '').trim()
                if (!questionText || seenQuestions.has(questionText)) return
                seenQuestions.add(questionText)
                allQuestions.push(questionText)
            })
        })

        const dataToExport = inscriptionsWithQuestions.map(inscription => {
            const baseRow = {
                [t('inscriptions.client')]: `${inscription?.client?.firstname || ''} ${inscription?.client?.lastname || ''}`,
                [t('users.email')]: inscription?.clientEmail || '',
                [t('users.phone')]: inscription?.client?.phone || '',
                [t('inscriptions.club')]: inscription?.club?.name || '',
                [`${t('groups.activity')} / ${t('groups.category')}`]: `${inscription?.activity?.title || ''} / ${inscription?.category?.title || ''}`,
                [`${t('inscriptions.group')} / ${t('inscriptions.horary')}`]: `${inscription?.group?.title || ''} / ${inscription?.horary?.name || ''}`,
                [t('inscriptions.status')]: t('inscriptions.status' + inscription.status),
                [t('inscriptions.policy')]: inscription?.policy ? t('global.yes') : t('global.no'),
                [t('inscriptions.minorsPolicy')]: inscription?.minorsPolicy ? t('global.yes') : t('global.no'),
                [t('inscriptions.sendMarketPolicy')]: inscription?.sendMarketPolicy ? t('global.yes') : t('global.no')
            }

            const answerByQuestion = new Map()
            const inscriptionQuestions = Array.isArray(inscription?.questions) ? inscription.questions : []
            inscriptionQuestions.forEach((questionItem) => {
                const questionText = String(questionItem?.question || '').trim()
                if (!questionText) return
                answerByQuestion.set(questionText, String(questionItem?.answer || '').trim())
            })

            allQuestions.forEach((questionText) => {
                baseRow[`Pregunta: ${questionText}`] = answerByQuestion.get(questionText) || ''
            })

            return baseRow
        })

        const ws = XLSX.utils.json_to_sheet(dataToExport)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Inscripciones')
        
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').replace('T', '_').split('Z')[0]
        const fileName = `inscripciones_${isclub ? club?.name + '_' : ''}${timestamp}.xlsx`
        XLSX.writeFile(wb, fileName)
    }

    const ExpandedRow = ({ data }) => {
        return (
            <Container className='p-3'>
                <Row>
                    <Col xs={12} lg={6}>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('users.birthdate')}</small> {formatDate(data?.client?.birthdate)}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('users.phone')}</small> {data?.client?.phone}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('users.emergencyphone')}</small> {data?.client?.emergencyPhone}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('users.email')}</small> {data?.clientEmail}
                        </div>
                        {data?.client?.identityDocuments?.length > 0
                        ?
                            <div className='d-flex flex-column border-1 border-bottom p-2'>
                                {data?.client?.identityDocuments?.map((doc, index) => (
                                    <div key={index} className='d-flex justify-content-between'>
                                        <small className='text-uppercase'>{doc.documentType}</small>{doc.documentNumber}
                                    </div>
                                ))}
                            </div>
                         :
                            <></>
                        }
                         {data?.client?.addresses?.length > 0
                        ?
                            <div className='d-flex flex-column border-1 border-bottom p-2'>
                                {data?.client?.addresses?.map((address, index) => (
                                    <div key={index} className='d-flex justify-content-between'>
                                        <small className='text-uppercase'>{t('menus.config.address')}</small>
                                        <div className='text-end'>
                                            {address.address}<br/>
                                            {address.town} ({address.province})<br/>
                                            {address.postalCode}
                                        </div>
                                    </div>
                                ))}
                            </div>
                         :
                            <></>
                        }
                    </Col>
                    <Col xs={12} lg={6}>
                        {data?.tutor1Name
                            ?
                                <>
                                    <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                        <small>{t('users.tutor1Name')}</small> {data?.tutor1Name}
                                    </div>
                                    <div className='d-flex justify-content-between border-bottom p-2'>
                                        <small>{t('users.tutor1Phone')}:</small> {data?.tutor1Phone}
                                    </div>
                                    <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                        <small>{t('users.tutor1Email')}</small> {data?.tutor1Email}
                                    </div>
                                    <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                        <small>{t('users.tutor2Name')}</small> {data?.tutor2Name}
                                    </div>
                                    <div className='d-flex justify-content-between border-bottom p-2'>
                                        <small>{t('users.tutor2Phone')}:</small> {data?.tutor2Phone}
                                    </div>
                                    <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                        <small>{t('users.tutor2Email')}</small> {data?.tutor2Email}
                                    </div>
                                </>
                            :
                                <></>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }

    // Efecto para manejar el resultado de cancelar todas las inscripciones activas
    useEffect(() => {
        if (resultinscription === 'cancelAllActiveSuccess') {
            dispatch({ type: 'INSCRIPTION_RESET_RESULT' })
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                title: t('inscriptions.cancelAllActiveSuccessTitle'),
                text: t('inscriptions.cancelAllActiveSuccessText', { count: cancelAllCount ?? 0 })
            }).then(() => {
                setCurrentPage(1)
                setSearchInput('')
                setDebouncedSearch('')
            })
        }
    // eslint-disable-next-line
    }, [resultinscription])

    const handleCancelAllActive = () => {
        const activeCount = inscriptions?.filter(i => i.status === "2").length ?? 0
        Swal.fire({
            title: t('inscriptions.cancelAllActiveConfirmTitle'),
            html: t('inscriptions.cancelAllActiveConfirmText', { count: activeCount }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('inscriptions.cancelAllActiveConfirmBtn'),
            cancelButtonText: t('global.no')
        }).then((swalResult) => {
            if (swalResult.isConfirmed && club?._id) {
                dispatch(cancelAllActiveInscriptionsByClub(club._id, clientauth?.id))
            }
        })
    }

    return (
        <>
            <Container className='cuerpo'>
                {
                    isclub
                    ?
                        <Row>
                            <Col>
                                <ClubBreadCrumbs usertype={usertype} club={club} />
                            </Col>
                        </Row>

                    :
                        <></>
                }
                <Row>
                    <Col className='d-flex align-items-center'>
                        <h1 className='ms-2 my-0'>{t('menus.activities.inscriptions')}</h1>
                    </Col>
                </Row>
                {
                    isclub
                    ?
                        <Row className="my-3">
                            <Col>
                                <ActivitiesSubMenu usertype={usertype} active="inscriptions"/>
                            </Col>
                        </Row>
                    :
                        <></>
                }

                <Row className="my-3">
                    <Col>
                        <Card>
                            {loadinginscriptions
                            ?
                                <Loader/>
                            :
                                <Card.Body>
                                    <div className="my-3">
                                        <Row>
                                            <Col>
                                                <div className="d-flex justify-content-between align-items-end gap-2 mb-3 flex-wrap">
                                                    <div style={{flex: 1}}></div>
                                                    <div className='d-flex flex-column align-items-center' style={{flex: 1}}>
                                                        <h2 className='mb-1'>Buscador</h2>
                                                        <div className='data-table-extensions-filter'>
                                                            <span className='icon' />
                                                            <input
                                                                type='text'
                                                                className='filter-text'
                                                                placeholder={t('datatables.buscar')}
                                                                value={searchInput}
                                                                onChange={(e) => {
                                                                    setSearchInput(e.target.value)
                                                                    setCurrentPage(1)
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column align-items-end' style={{flex: 1}}>
                                                        {isclub && club?._id && (
                                                            <Button
                                                                variant="danger"
                                                                onClick={handleCancelAllActive}
                                                                className="mb-2"
                                                            >
                                                                <i className="fas fa-ban me-2"></i>
                                                                {t('inscriptions.cancelAllActive')}
                                                            </Button>
                                                        )}
                                                        <Button variant="success" onClick={exportToExcel} disabled={!inscriptions?.length}>
                                                            <i className="fas fa-file-excel me-2"></i>
                                                            {t('global.exportToExcel')}
                                                        </Button>
                                                    </div>
                                                </div>
                                                {inscriptions?.length > 0 ?
                                                    <>
                                                        <CustomDataTable
                                                            key={`${isclub ? club?._id || 'club' : 'admin'}-${rowsPerPage}`}
                                                            columns={columnsInscriptions}
                                                            data={translatedInscriptions}
                                                            exportable={false}
                                                            printable={false}
                                                            expandedData={ExpandedRow}
                                                            paginationServer={true}
                                                            paginationTotalRows={pagination?.total || 0}
                                                            paginationPerPage={rowsPerPage}
                                                            paginationDefaultPage={currentPage}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleRowsPerPageChange}
                                                        />
                                                    </>
                                                :
                                                    <div className='contenedor-vacio text-center'>
                                                        <h4>{t('inscriptions.thereisnotinscriptions')}</h4>
                                                        {t('inscriptions.thereisnotinscriptionsphrase')}
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </Card.Body>
                            }
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>{t('inscriptions.datainscription')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='cuerpo px-5 py-4'>
                    <InscriptionSummary
                        usertype={usertype}
                        typeform={typeform}
                        inscriptionselected={inscriptionselected}
                        closeModal={handleClose}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}